export const menus = [
    // {
    //     id: 1014,
    //     title: "Menu",
    //     route_name: 'menu',
    //     icon: "fas fa-ellipsis-h",
    // },

    // {
    //     id: 1041,
    //     title: "Kateqoriyalar",
    //     route_name: 'category',
    //     icon: "fas fa-list",
    // },

    // {
    //     id: 1092,
    //     title: "Rollar",
    //     route_name: 'roles',
    //     icon: "fas fa-user-check",
    // },
    // {
    //     id: 1094,
    //     title: "Istifadəçilər",
    //     route_name: 'users',
    //     icon: "fas fa-users",
    // },
    {
        id: 100,
        title: "Əsas",
        icon: "fas fa-home",
        collapsed: true,
        visible: true,
        items: [
            {
                id: 101,
                title: "Dashboard",
                route_name: 'dashboard',
                icon: "fas fa-th",
                // link: "/dashboard",
            },
            // {
            //     id: 102,
            //     title: "Dashboard 2",
            //     route_name: 'dashboard2',
            //     icon: "fas fa-th",
            //     // link: "/dashboard",
            // },
            {
                id: 105,
                title: "Map",
                route_name: 'map',
                icon: "fas fa-map",
                // link: "/products",
            },

            {
                id: 104,
                title: "-",
                role: "user",
            },

            {
                id: 106,
                title: "Devices",
                route_name: 'devices',
                icon: "fas fa-microchip",
                // link: "/products",
            },
            {
                id: 107,
                title: "Register",
                route_name: 'register',
                icon: "fas fa-code-branch",
                // link: "/products",
            },
        ]
    },
    {
        id: 150,
        title: "Sistem",
        icon: "fas fa-user-cog",
        collapsed: true,
        visible: true,
        items: [
            {
                id: 151,
                title: "Filter qrupu",
                route_name: 'filter',
                icon: "fas fa-filter",
                // link: "/manufacturer",
            },
            // {
            //     id: 152,
            //     title: "İstehsalçı",
            //     route_name: 'manufacturer',
            //     icon: "fas fa-industry",
            //     // link: "/manufacturer",
            // },

            {
                id: 155,
                title: "-",
                // role: "user",
            },

            {
                id: 156,
                title: "Rollar",
                route_name: 'roles',
                icon: "fas fa-user-check",
                // link: "/role",
            },
            {
                id: 157,
                title: "Istifadəçilər",
                route_name: 'users',
                icon: "fas fa-users",
                // link: "/user",
            },

            {
                id: 158,
                title: "-",
                // role: "user",
            },

    //     ]
    // },
    // {
    //     id: 200,
    //     title: 'Sazlama',
    //     icon: 'fas fa-cogs',
    //     collapsed: true,
    //     visible: true,
    //     items: [
            {
                id: 158,
                title: "Sözlük",
                route_name: 'lang',
                icon: "fas fa-language",
                // link: "/language",
            },
            {
                id: 159,
                title: "Sistem",
                route_name: 'settings',
                icon: "fas fa-cog",
                // link: "/system",
            },
        ],
    },
    {
        id: 250,
        title: "Məlumat",
        icon: "fas fa-info-circle",
        collapsed: true,
        visible: true,
        items: [
            {
                id: 251,
                title: "Profilim",
                route_name: 'profile',
                icon: "fas fa-user",
                // link: "/profile",
            },
            {
                id: 252,
                title: "About",
                route_name: 'about',
                icon: "fas fa-info-circle",
                // link: "/about",
            },
        ]
    }
];
